import React from 'react';
import PropTypes from 'prop-types';
import classes from './ErrorMessage.module.scss';

const ErrorMessage = ({ children }) => (
  <div className={classes.errorMessageText}>{children}</div>
);

ErrorMessage.propTypes = {
  children: PropTypes.string.isRequired,
};

export default ErrorMessage;
